<template>
<div class="share-scope-wrap">
        <transition name="fade-in-linear" v-if="showShareScope">
            <div class="popover-share-scope">
                <div class="share-view">
                    <div class="popover-share-content">
                        <div class="popover-share-top">
                            <div class="popover-share-top-title">{{$t("分享")}}</div>
                            <div class="close-btn" @click.stop="closeShareScopeView">
                                <img src="@/assets/img/share/icon_file_close.png"/>
                            </div>
                        </div>

                        <div class="popover-share-center">
                            <div class="popover-share-center-title">{{$t("链接分享范围")}}                                <div v-if="myAuth !== null" class="popover-share-center-title-auth-manage" @click.stop="pushToShareView">
                                    <img src="@/assets/img/share/icon_file_add_worker.png"/>{{myAuth === 'ALL' ||
myAuth === 'WRITE' && isCreator ? $t("权限管理") : $t("查看协作者")}}                                </div>
                            </div>
                            <div id="link_share_range_set_share_scope_view"></div>
                        </div>
                    </div>

                    <div class="popover-share-bottom">
                        <div class="popover-share-bottom-copy-btn" @click="getShareUrl">
                            <img src="@/assets/img/share/icon_file_copy_link.png"/>{{$t("复制链接")}}                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div ref="popoverSlot">
            <slot name="reference"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { getShareInfo, getShareUrl } from '../../core/api/file';
import { mapState, mapActions } from 'vuex';
import { store } from '../../store/store';
import { TocaWikiLinkShareRangeSet } from '@toca/toca-wiki-template';
import '@toca/toca-wiki-template/dist/style.css';
import { getShareAuthTip } from './shareUtil';

export default {
  name: 'FileShareScopeView',
  props: {
    showShareScope: {
      type: Boolean,
      default: false },

    myAuth: {
      type: String },

    fileId: {
      type: String,
      default: '',
      required: true },

    fileUrl: {
      type: String,
      default: '',
      required: true },

    creatorInfo: {
      type: Object },

    userInfo: {
      type: Object } },


  components: {},
  watch: {
    showShareScope: {
      handler: function (val: boolean) {
        if (val) {
          this.$nextTick(() => {
            this.mountLinkShareRangeSet();
          });
          this.getShareInfo();
        }
      } } },


  data() {
    return {
      shareAuth: '',
      shareScope: '',
      loadSuccess: true,
      shareUrl: null,
      authInfo: '',
      spaceInfo: null,
      linkShareRangeSet: null,
      canUpdateUrlAuth: false };

  },
  emits: ['closeShareScopeView', 'pushToShareView', 'updateLinkShareRange', 'onLinkRangeSetDropdownVisible', 'UpdateLinkShareRangeSet'],
  computed: {
    ...mapState({
      shareAuthTip: (state) => state.kbEditModule.shareAuthTip,
      wikiI18n: (state) => state.kbModule.wikiI18n,
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo }),

    isCreator() {
      return (
        this.creatorInfo &&
        this.userInfo.userId === this.creatorInfo.userId &&
        this.userInfo.spaceId === this.creatorInfo.spaceId);

    } },

  methods: {
    ...mapActions({
      setShareAuthTip: `kbEditModule/setShareAuthTip` }),

    updateShareInfo(auth, scope, fileId) {
      this.shareAuth = auth;
      this.shareScope = scope;
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, null, '', {
          spaceId: this.wikiSpaceInfo?.id,
          spaceName: this.wikiSpaceInfo?.spaceName });

      }
      const tip = getShareAuthTip(auth, scope, this.spaceInfo);
      this.setShareAuthTip(tip);
    },
    mountLinkShareRangeSet() {
      try {
        const cookies = {
          token: store.state.userModule.token,
          spaceId: store.state.userModule.spaceId,
          userId: store.state.userModule.userId,
          deviceId: store.state.userModule.deviceId,
          memberUniqueId: store.state.userModule.userDetail?.id,
          memberId: store.state.userModule.userDetail?.id };

        this.linkShareRangeSet = new TocaWikiLinkShareRangeSet('#link_share_range_set_share_scope_view', {
          locale: this.wikiI18n,
          env: import.meta.env.MODE,
          userInfo: cookies,
          onlyShowAuthDesc: false,
          isWiki: true,
          fileId: this.fileId,
          canUpdateLinkShareRange: this.canUpdateUrlAuth,
          shareAuth: '',
          shareScope: '',
          shareExpireDate: null,
          sharePassword: '',
          spaceInfo: this.spaceInfo,
          onUpdateShareRange: (auth, scope, expireDate, password, spaceInfo, shareAuthTip) => {
            console.log('V------------------------link_share_range_set_share_scope_view-----------------');
            this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo, shareAuthTip);
          },
          onUpdateShareAuthTip: (tip) => {
            this.setShareAuthTip(tip);
          },
          onLinkRangeSetDropdownVisible: (domId, visible) => {
            this.$emit('onLinkRangeSetDropdownVisible', domId, visible);
          } });

      } catch (error) {
        console.error(intl.$t("TocaWikiLinkShareRangeSet 初始化失败:"), error);
      }
    },
    closeShareScopeView() {
      this.$emit('closeShareScopeView', false);
    },
    async getShareInfo() {
      try {
        const res = await getShareInfo(this.fileId);
        const { code, data, message }: any = res.data || {};
        if (code === 200) {
          if (data === null || data === undefined) {
            return;
          }
          const {
            auth,
            scope,
            expireDate,
            password,
            spaceInfo,
            memberAcl } =
          data;
          this.shareAuth = auth;
          this.shareScope = scope;
          this.spaceInfo = spaceInfo;
          this.canUpdateUrlAuth = memberAcl?.canUpdateUrlAuth;

          this.$emit('UpdateLinkShareRangeSet', this.canUpdateUrlAuth);
          this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo);
          if (this.linkShareRangeSet) {
            this.linkShareRangeSet.updateShareRangeInfo(auth, scope, expireDate, password, spaceInfo);
            this.linkShareRangeSet.UpdateLinkShareRangeSet(this.canUpdateUrlAuth);
          }

          //设置tip
          const tip = getShareAuthTip(auth, scope, spaceInfo);
          this.setShareAuthTip(tip);
        } else {
          this.loadSuccess = false;
        }
      } catch (error) {
        this.loadSuccess = false;
      }
    },
    getShareUrl() {
      this.createCopyArea(this.fileUrl);
    },
    createCopyArea(url: string) {
      navigator.clipboard.
      write([
      new ClipboardItem({
        'text/plain': new Blob([url], { type: 'text/plain' }) })]).


      then(() => {
        if (this.shareScope === 'COLLABORATOR') {
          this.$message.success(intl.$t("链接已复制，仅协作者可查看，请确认对方是否为协作者"));


        } else {
          const tip = getShareAuthTip(this.shareAuth, this.shareScope, this.spaceInfo, false);
          this.$message.success(intl.$t(`链接已复制，{tip}`, { tip: tip }));
        }
      }).
      catch((err) => {
        console.error('Failed to copy HTML: ', err);
        this.$message.error(intl.$t("链接复制失败"));
      });
    },
    pushToShareView() {
      this.$emit('pushToShareView');
    } },

  created() {
    // this.getShareInfo();
  },
  unmounted() {
    if (this.linkShareRangeSet) {
      this.linkShareRangeSet.destroy();
      this.linkShareRangeSet = null;
    }
  } };
</script>

<style lang="scss" scoped>
.share-scope-wrap {
    position: relative;

    .popover-share-scope {
        top: 32px;
        right: 0;
        width: 400px;
        position: absolute;
        z-index: 2000;
        background-color: #fff;
        border-radius: 10px;
        border: 1px solid #e6e8ec;
        box-shadow: 0 8px 12px 0 #1213171a;
        min-height: 204px;
        display: flex;
        flex-direction: column;

        .share-view {
            display: flex;
            flex-direction: column;

            .popover-share-content {
                display: flex;
                flex-direction: column;
                flex: 1;
                margin: 16px 16px 0px 16px;

                .popover-share-top {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    line-height: 100%;
                    margin-bottom: 24px;

                    .popover-share-top-title {
                        display: flex;
                        flex: 1;
                        font-size: 16px;
                        font-weight: 500;
                        color: #121317;
                        line-height: 24px;
                    }

                    .close-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 24px;
                        height: 24px;
                        cursor: pointer;

                        img {
                            width: 14px;
                            height: 14px;
                            object-fit: contain;
                        }

                        &:hover {
                            background-color: #f4f6f9;
                            border-radius: 4px;
                        }
                    }
                }

                .popover-share-center {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    margin-bottom: 24px;

                    .popover-share-center-title {
                        font-size: 14px;
                        font-weight: 500;
                        font-family: PingFangSC-Medium;
                        color: #323233;
                        line-height: 20px;
                        margin-bottom: 16px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;

                        .popover-share-center-title-auth-manage {
                            color: #5c70ff;
                            cursor: pointer;
                            font-size: 14px;
                            font-weight: 400;
                            font-family: PingFangSC-Regular;
                            line-height: 20px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 2px 8px;

                            img {
                                width: 12px;
                                height: 12px;
                                margin-right: 4px;
                            }

                            &:hover {
                                background-color: #edefff;
                                border-radius: 6px;
                            }
                        }
                    }

                    #link_share_range_set_share_scope_view {
                        width: 100%;
                    }
                }
            }

            .popover-share-bottom {
                height: 52px;
                width: 100%;
                background-color: #f5f6f7;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                border-radius: 0 0 10px 10px;

                .popover-share-bottom-copy-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 16px;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 300;
                    font-family: PingFangSC-Regular;
                    color: #fff;
                    line-height: 20px;
                    background-color: #5c70ff;
                    width: 100px;
                    height: 36px;
                    border-radius: 8px;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 4px;
                    }

                    &:hover {
                        background-color: #6d7dff;
                    }
                }
            }
        }
    }
}
</style>
